import { coerceBooleanProperty } from '@angular/cdk/coercion';
import * as i0 from '@angular/core';
import { EventEmitter, QueryList, ElementRef, Component, ChangeDetectionStrategy, ViewEncapsulation, Input, Output, ViewChild, ViewChildren, NgModule } from '@angular/core';
import { Observable, debounceTime, distinctUntilChanged } from 'rxjs';
import * as i1 from '@niceltd/sol/translation';
import * as i2 from '@niceltd/sol/chip';
import { ChipModule } from '@niceltd/sol/chip';
import * as i3 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i4 from '@niceltd/sol/button';
import { ButtonModule } from '@niceltd/sol/button';
import * as i5 from '@niceltd/sol/icon';
import { IconModule } from '@niceltd/sol/icon';
const _c0 = ["showMoreEleRef"];
const _c1 = ["showLessEleRef"];
const _c2 = ["invisibleMoreEleRef"];
const _c3 = ["tagWrapperEleRef"];
const _c4 = ["invisibleItemEleRef"];
const _c5 = ["invisibleChips"];
const _c6 = (a0, a1) => ({
  tag: a0,
  chipIndex: a1
});
function SelectedTagsComponent_div_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 14);
    i0.ɵɵelementContainer(1, 15);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r15 = ctx.$implicit;
    const i_r16 = ctx.index;
    i0.ɵɵnextContext();
    const _r6 = i0.ɵɵreference(11);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", _r6)("ngTemplateOutletContext", i0.ɵɵpureFunction2(2, _c6, item_r15, i_r16));
  }
}
function SelectedTagsComponent_ng_container_4_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 17);
    i0.ɵɵelementContainer(1, 15);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r18 = ctx.$implicit;
    const j_r19 = ctx.index;
    const ctx_r17 = i0.ɵɵnextContext(2);
    const _r6 = i0.ɵɵreference(11);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", _r6)("ngTemplateOutletContext", i0.ɵɵpureFunction2(2, _c6, item_r18, ctx_r17.visibleItems.length + j_r19));
  }
}
function SelectedTagsComponent_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, SelectedTagsComponent_ng_container_4_div_1_Template, 2, 5, "div", 16);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r2.hiddenItems);
  }
}
function SelectedTagsComponent_div_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 18, 19);
    i0.ɵɵelement(2, "sol-chip", 20, 21);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r20 = ctx.$implicit;
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("allowClose", ctx_r3.removable)("label", item_r20[ctx_r3.label])("subLabel", item_r20[ctx_r3.subLabel])("size", ctx_r3.tagSize)("id", "sol-invisible-chip-" + item_r20[ctx_r3.primaryKey]);
    i0.ɵɵattribute("data-primary-value", item_r20[ctx_r3.primaryKey]);
  }
}
function SelectedTagsComponent_ng_template_10_Template(rf, ctx) {
  if (rf & 1) {
    const _r26 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "sol-chip", 22);
    i0.ɵɵlistener("closed", function SelectedTagsComponent_ng_template_10_Template_sol_chip_closed_0_listener() {
      const restoredCtx = i0.ɵɵrestoreView(_r26);
      const tag_r23 = restoredCtx.tag;
      const ctx_r25 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r25.removeItem(tag_r23));
    })("chipKeydown", function SelectedTagsComponent_ng_template_10_Template_sol_chip_chipKeydown_0_listener($event) {
      const restoredCtx = i0.ɵɵrestoreView(_r26);
      const chipIndex_r24 = restoredCtx.chipIndex;
      const ctx_r27 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r27.onChipKeydown($event, chipIndex_r24));
    })("closeButtonKeydown", function SelectedTagsComponent_ng_template_10_Template_sol_chip_closeButtonKeydown_0_listener($event) {
      const restoredCtx = i0.ɵɵrestoreView(_r26);
      const chipIndex_r24 = restoredCtx.chipIndex;
      const ctx_r28 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r28.onCloseButtonKeydown($event, chipIndex_r24));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const tag_r23 = ctx.tag;
    const chipIndex_r24 = ctx.chipIndex;
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵproperty("chipTabIndex", chipIndex_r24 === 0 ? "0" : "-1")("allowClose", ctx_r5.removable)("label", tag_r23.labelText)("subLabel", tag_r23.subLabelText)("size", ctx_r5.tagSize)("id", "sol-visible-chip-" + tag_r23.primaryValue)("variant", ctx_r5.variant);
  }
}
function SelectedTagsComponent_ng_template_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(0, "svg", 23);
    i0.ɵɵelement(1, "path", 24);
    i0.ɵɵelementEnd();
  }
}
function SelectedTagsComponent_ng_template_14_sol_button_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r34 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "sol-button", 29, 30);
    i0.ɵɵlistener("onClick", function SelectedTagsComponent_ng_template_14_sol_button_1_Template_sol_button_onClick_0_listener() {
      i0.ɵɵrestoreView(_r34);
      const ctx_r33 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r33.showMore());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r29 = i0.ɵɵnextContext(2);
    const _r12 = i0.ɵɵreference(17);
    i0.ɵɵproperty("id", "show-more-container-" + ctx_r29.id)("variant", "basic")("size", ctx_r29.tagSize)("iconPositionedFront", _r12)("ariaLabel", ctx_r29.showMoreAriaLabel);
  }
}
function SelectedTagsComponent_ng_template_14_sol_button_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r37 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "sol-button", 31, 32);
    i0.ɵɵlistener("onClick", function SelectedTagsComponent_ng_template_14_sol_button_2_Template_sol_button_onClick_0_listener() {
      i0.ɵɵrestoreView(_r37);
      const ctx_r36 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r36.showLess());
    });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r30 = i0.ɵɵnextContext(2);
    const _r14 = i0.ɵɵreference(19);
    i0.ɵɵproperty("id", "show-less-container-" + ctx_r30.id)("variant", "basic")("size", ctx_r30.tagSize)("iconPositionedFront", _r14);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r30.showLessLabel);
  }
}
function SelectedTagsComponent_ng_template_14_sol_button_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r39 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "sol-button", 33);
    i0.ɵɵlistener("onClick", function SelectedTagsComponent_ng_template_14_sol_button_3_Template_sol_button_onClick_0_listener() {
      i0.ɵɵrestoreView(_r39);
      const ctx_r38 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r38.clearAllTags());
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r31 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("size", ctx_r31.tagSize)("variant", "text");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("", ctx_r31.clearAllLabel, " ");
  }
}
function SelectedTagsComponent_ng_template_14_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 25);
    i0.ɵɵtemplate(1, SelectedTagsComponent_ng_template_14_sol_button_1_Template, 2, 5, "sol-button", 26)(2, SelectedTagsComponent_ng_template_14_sol_button_2_Template, 3, 5, "sol-button", 27)(3, SelectedTagsComponent_ng_template_14_sol_button_3_Template, 2, 3, "sol-button", 28);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r9 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r9.hiddenItems.length > 0 && !ctx_r9.showAll);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r9.hiddenItems.length > 0 && ctx_r9.showAll);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r9.visibleItems.length + ctx_r9.hiddenItems.length > 0 && ctx_r9.allowClearAll);
  }
}
function SelectedTagsComponent_ng_template_16_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵelement(1, "sol-icon", 34);
    i0.ɵɵelementStart(2, "span");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r11 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("icon", "sol-plus")("height", "0.65rem")("width", "0.65rem")("ariaHidden", true);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r11.hiddenItems.length);
  }
}
function SelectedTagsComponent_ng_template_18_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(0, "svg", 35);
    i0.ɵɵelement(1, "path", 36);
    i0.ɵɵelementEnd();
  }
}
let selectedTagsCount = 1;
class SelectedTagsComponent {
  set id(id) {
    this._id = id;
  }
  get id() {
    if (!this._id) {
      return `sol-selected-tags-${this._uniqueId}`;
    }
    return this._id;
  }
  /**
   * Used to describe the whether the chips should be removable or not
   */
  get removable() {
    return this._removable;
  }
  set removable(value) {
    this._removable = coerceBooleanProperty(value);
  }
  constructor(cdr, translationService) {
    this.cdr = cdr;
    this.translationService = translationService;
    this._id = '';
    this._removable = false;
    /**
     * Describes Chip size
     */
    this.tagSize = 'small';
    /**
     * Describes Chip variant
     */
    this.variant = 'basic';
    /**
     * Displays clear all button if true
     */
    this.allowClearAll = true;
    /**
     * User can set maximum number of displayed tags to be a very large number. In order to avoid
     * displaying many tags on clutter the DOM, we set an inner maximum value of tags.
     * The display value will be the minimum between the user supplied value and this value.
     */
    this.MAX_ALLOWED_TAGS_TO_DISPLAY = 10;
    /**
     * Selects the label property of the object which is to be displayed
     */
    this.primaryKey = 'id';
    /**
     * Selects the label property of the object which is to be displayed
     */
    this.label = 'text';
    /**
     * Selects the sublabel property of the object which is to be displayed
     */
    this.subLabel = 'subLabel';
    /**
     * Maximum number of tags to display. If this value is passed, the component will display this number of tags,
     * and the container will increase in size. If this is not passed or 0 is passed, the component will behave regularly,
     * only displaying the amount of tags that fits into the container.
     */
    this.maxTagsToDisplay = 0;
    /**
     * event to be triggered when there is change in tagsSource
     */
    this.tagsChanged = new EventEmitter();
    /**
     * event to be triggered when the 'x +' button is clicked.
     */
    this.viewMoreClicked = new EventEmitter();
    /**
     * event to be triggered when the 'show less' button is clicked.
     */
    this.viewLessClicked = new EventEmitter();
    /**
     * event to be triggered when a tag is removed
     */
    this.tagDeleted = new EventEmitter();
    /**
     * event to be triggered when all tags are removed
     */
    this.deleteAllClicked = new EventEmitter();
    /**
     * reference to hidden items rendered for calculation of width
     */
    this.invisibleItemsRef = new QueryList();
    this.visibleItems = [];
    this.hiddenItems = [];
    this._showAll = false;
    this.clearAllLabel = this.translationService.getTranslation('clearAll');
    this.showLessLabel = this.translationService.getTranslation('showLess');
    this.showMoreAriaLabel = this.translationService.getTranslation('showMoreAriaLabel', this.hiddenItems.length);
    this._uniqueId = selectedTagsCount++;
  }
  set showAll(val) {
    this._showAll = val;
    this.cdr.detectChanges();
  }
  get showAll() {
    return this._showAll;
  }
  ngOnChanges(changes) {
    if (changes.tagsSource && !changes.tagsSource.firstChange) {
      this.tagsSource = changes.tagsSource.currentValue;
      this.cdr.detectChanges();
      this.renderSelectedTags();
    }
  }
  resizeObservable(elem) {
    return new Observable(subscriber => {
      const ro = new ResizeObserver(entries => {
        subscriber.next(entries);
      });
      // Observe one or multiple elements
      ro.observe(elem);
      return function unsubscribe() {
        ro.unobserve(elem);
      };
    });
  }
  ngAfterViewInit() {
    this.tagsWrapperNativeElement = this.tagWrapperEleRef.nativeElement;
    this.resizeSubscription$ = this.resizeObservable(this.tagsWrapperNativeElement).pipe(debounceTime(200), distinctUntilChanged()).subscribe(entries => {
      // perform when items are not expanded and max tags is not given
      if (!this.showAll && this.maxTagsToDisplay <= 0) {
        for (const entry of entries) {
          // if width is 0 or same width, then don't re render
          if (entry.contentRect.width > 0 && this.currentWidth !== entry.contentRect.width) {
            this.renderSelectedTags();
          }
          this.currentWidth = entry.contentRect.width;
        }
      }
    });
    this.renderSelectedTags();
  }
  renderSelectedTags() {
    const containerWidth = this.tagWrapperEleRef.nativeElement.offsetWidth;
    const chips = this.invisibleChips.toArray();
    const items = this.invisibleItemsRef.toArray().map((x, index) => {
      return {
        width: x.nativeElement.offsetWidth,
        labelText: chips[index].label,
        subLabelText: chips[index].subLabel,
        primaryValue: x.nativeElement.children[0].getAttribute('data-primary-value')
      };
    });
    this.prepareItemsToDisplay(items, containerWidth);
    // trigger change detection here to update dom
    this.cdr.detectChanges();
  }
  prepareItemsToDisplay(items, containerWidth) {
    this.maxTagsToDisplay = Math.min(this.maxTagsToDisplay, this.MAX_ALLOWED_TAGS_TO_DISPLAY);
    if (this.maxTagsToDisplay > 0) {
      if (this.maxTagsToDisplay > items.length) {
        this.visibleItems = [...items];
        this.hiddenItems = [];
      } else {
        this.visibleItems = [...items.slice(0, this.maxTagsToDisplay)];
        this.hiddenItems = [...items.slice(this.maxTagsToDisplay, items.length)];
      }
    } else {
      this.prepareSelectedItems(items, containerWidth);
    }
  }
  /* prepares the selectedTags dynamically based on the available container width */
  prepareSelectedItems(items, containerWidth) {
    let hiddenStartIndex = -1;
    let hiddenItems = [];
    let visibleItems = [];
    // this offset is due to gap between chips
    const offset = 4;
    let moreWidth = 0;
    if (this.invisibleMoreEleRef && this.invisibleMoreEleRef.nativeElement) {
      moreWidth += this.invisibleMoreEleRef.nativeElement.offsetWidth;
    }
    let remainingWidth = containerWidth - moreWidth;
    for (let i = 0; i < items.length; i += 1) {
      const itemWidth = items[i].width;
      remainingWidth = remainingWidth - itemWidth - offset;
      if (remainingWidth < 0) {
        hiddenStartIndex = i;
        break;
      }
    }
    if (hiddenStartIndex === -1) {
      visibleItems = items;
    } else {
      visibleItems = items.slice(0, hiddenStartIndex);
      hiddenItems = items.slice(hiddenStartIndex, items.length);
    }
    this.visibleItems = [...visibleItems];
    this.hiddenItems = [...hiddenItems];
    this.showMoreAriaLabel = this.translationService.getTranslation('showMoreAriaLabel', this.hiddenItems.length);
  }
  /* This function removes tags from selected tags array */
  removeItem(tag) {
    const indexFound = this.tagsSource.findIndex(x => '' + x[this.primaryKey] === tag.primaryValue);
    const tagToBeDeleted = this.tagsSource.find(x => '' + x[this.primaryKey] === tag.primaryValue);
    if (indexFound > -1 && tagToBeDeleted) {
      this.tagsSource.splice(indexFound, 1);
      this.tagsChanged.emit({
        tags: this.tagsSource
      });
      this.tagDeleted.emit(tagToBeDeleted);
      this.cdr.detectChanges();
      this.renderSelectedTags();
      const totalTagsLength = this.invisibleChips.length;
      const chipCloseIcons = this.tagWrapperEleRef.nativeElement.querySelectorAll('.sol-tags-wrapper .chip-item .sol-chip .close-icon');
      if (totalTagsLength) {
        // if closed chip is not the first chip then focus returns to the previous chip
        if (indexFound > 0) {
          const previousChipIcon = chipCloseIcons[indexFound - 1];
          previousChipIcon.focus();
        }
        // if closed chip is the first chip then focus returns to the new first chip when explaned
        else if (this.showAll) {
          const previousChipIcon = chipCloseIcons[indexFound];
          previousChipIcon.focus();
        }
        // if closed chip is the first chip then focus returns to the new first chip if its visible
        else if (chipCloseIcons.length > 0) {
          const chipIcon = chipCloseIcons[indexFound];
          chipIcon.focus();
        }
      }
    }
  }
  onCloseButtonKeydown(event, index) {
    const chipItems = this.tagWrapperEleRef.nativeElement.querySelectorAll('.sol-tags-wrapper .chip-item .sol-chip');
    if (event.code === 'ArrowRight') {
      if (index < this.visibleItems.length - 1) {
        // focus next chip
        chipItems[index + 1].focus();
      } else if (index < this.visibleItems.length + this.hiddenItems.length - 1 && this.showAll) {
        // focus next chip
        chipItems[index + 1].focus();
      } else {
        // focus first chip
        chipItems[0].focus();
      }
    }
  }
  onChipKeydown(event, index) {
    const chipItems = this.tagWrapperEleRef.nativeElement.querySelectorAll('.sol-tags-wrapper .chip-item .sol-chip');
    const chipCloseIcons = this.tagWrapperEleRef.nativeElement.querySelectorAll('.sol-tags-wrapper .chip-item .sol-chip .close-icon');
    if (event.code === 'ArrowLeft') {
      // if removable then focus previous chip close icon
      if (this.removable) {
        // if it is not the first chip
        if (index > 0) {
          // focus previous chip close icon
          chipCloseIcons[index - 1].focus();
        }
        // if it is the first chip focus last chip close icon
        else if (index === 0) {
          if (this.showAll) {
            chipCloseIcons[this.visibleItems.length + this.hiddenItems.length - 1].focus();
          } else {
            chipCloseIcons[this.visibleItems.length - 1].focus();
          }
        }
      }
      // focus previous chip if removable is false
      // if it is not the first chip
      else if (index > 0) {
        // focus previous chip
        chipItems[index - 1].focus();
      }
      // if it is the first chip focus last chip
      else if (index === 0) {
        if (this.showAll) {
          chipItems[this.visibleItems.length + this.hiddenItems.length - 1].focus();
        } else {
          chipItems[this.visibleItems.length - 1].focus();
        }
      }
    } else if (!this.removable && event.code === 'ArrowRight') {
      // it works same as close button right keydown functionallity
      this.onCloseButtonKeydown(event, index);
    }
  }
  showMore() {
    this.showAll = true;
    // when show all is updated, dom is updated
    // because showAll us triggering changeDetection
    this.showLessEleRef.nativeElement.querySelector('button')?.focus();
    this.viewMoreClicked.emit();
  }
  showLess() {
    this.showAll = false;
    // when show all is updated, dom is updated
    // because showAll us triggering changeDetection
    this.showMoreEleRef.nativeElement.querySelector('button')?.focus();
    this.viewLessClicked.emit();
  }
  clearAllTags() {
    this.tagsSource = [];
    this.cdr.detectChanges();
    this.renderSelectedTags();
    this.deleteAllClicked.emit();
  }
  ngOnDestroy() {
    this.resizeSubscription$.unsubscribe();
  }
  static {
    this.ɵfac = function SelectedTagsComponent_Factory(t) {
      return new (t || SelectedTagsComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.TranslationService));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SelectedTagsComponent,
      selectors: [["sol-selected-tags"]],
      viewQuery: function SelectedTagsComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c0, 5, ElementRef);
          i0.ɵɵviewQuery(_c1, 5, ElementRef);
          i0.ɵɵviewQuery(_c2, 5);
          i0.ɵɵviewQuery(_c3, 5);
          i0.ɵɵviewQuery(_c4, 5);
          i0.ɵɵviewQuery(_c5, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.showMoreEleRef = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.showLessEleRef = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.invisibleMoreEleRef = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.tagWrapperEleRef = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.invisibleItemsRef = _t);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.invisibleChips = _t);
        }
      },
      inputs: {
        id: "id",
        tagsSource: "tagsSource",
        removable: "removable",
        tagSize: "tagSize",
        variant: "variant",
        allowClearAll: "allowClearAll",
        primaryKey: "primaryKey",
        label: "label",
        subLabel: "subLabel",
        maxTagsToDisplay: "maxTagsToDisplay"
      },
      outputs: {
        tagsChanged: "tagsChanged",
        viewMoreClicked: "viewMoreClicked",
        viewLessClicked: "viewLessClicked",
        tagDeleted: "tagDeleted",
        deleteAllClicked: "deleteAllClicked"
      },
      features: [i0.ɵɵNgOnChangesFeature],
      decls: 20,
      vars: 6,
      consts: [[1, "sol-selected-tags", 3, "id"], [1, "sol-tags-wrapper"], ["tagWrapperEleRef", ""], ["class", "sol-tag-horizontal visible-items chip-item", 4, "ngFor", "ngForOf"], [4, "ngIf"], [3, "ngTemplateOutlet"], ["class", "sol-tag-container invisible", 4, "ngFor", "ngForOf"], [1, "invisible"], ["invisibleMoreEleRef", ""], ["tagTemplate", ""], ["ShowLessIcon", ""], ["actionButtons", ""], ["plusCount", ""], ["backArrow", ""], [1, "sol-tag-horizontal", "visible-items", "chip-item"], [3, "ngTemplateOutlet", "ngTemplateOutletContext"], ["class", "sol-tag-horizontal hidden-items chip-item", 4, "ngFor", "ngForOf"], [1, "sol-tag-horizontal", "hidden-items", "chip-item"], [1, "sol-tag-container", "invisible"], ["invisibleItemEleRef", ""], ["chipTabIndex", "-1", 3, "allowClose", "label", "subLabel", "size", "id"], ["invisibleChips", ""], [3, "chipTabIndex", "allowClose", "label", "subLabel", "size", "id", "variant", "closed", "chipKeydown", "closeButtonKeydown"], ["width", "10", "height", "12", "viewBox", "0 0 10 12", "fill", "none", "xmlns", "http://www.w3.org/2000/svg"], ["d", "M5.12087 2.81633H2.36577L4.63107 1.10204C4.87597 0.857143 4.87597 0.428571 4.63107 0.183673C4.38618 -0.0612245 3.9576 -0.0612245 3.71271 0.183673L0.406584 2.81633C0.22291 3 0.161686 3.18367 0.22291 3.42857C0.161686 3.61224 0.22291 3.85714 0.406584 3.97959L3.77393 6.91837C4.01883 7.16327 4.4474 7.16327 4.6923 6.91837C4.9372 6.67347 4.9372 6.2449 4.6923 6L2.30454 4.04082H5.12087C6.9576 4.04082 8.48822 5.57143 8.48822 7.40816C8.48822 9.2449 6.9576 10.7755 5.12087 10.7755H2.97801C2.61067 10.7755 2.36577 11.0204 2.36577 11.3878C2.36577 11.7551 2.61067 12 2.97801 12H5.12087C7.63107 12 9.71271 9.91837 9.71271 7.40816C9.71271 4.89796 7.63107 2.81633 5.12087 2.81633Z", "fill", "#767676"], [1, "sol-selected-tags-buttons-container"], ["class", "show-more", 3, "id", "variant", "size", "iconPositionedFront", "ariaLabel", "onClick", 4, "ngIf"], ["class", "show-less", 3, "id", "variant", "size", "iconPositionedFront", "onClick", 4, "ngIf"], ["class", "clear-all", 3, "size", "variant", "onClick", 4, "ngIf"], [1, "show-more", 3, "id", "variant", "size", "iconPositionedFront", "ariaLabel", "onClick"], ["showMoreEleRef", ""], [1, "show-less", 3, "id", "variant", "size", "iconPositionedFront", "onClick"], ["showLessEleRef", ""], [1, "clear-all", 3, "size", "variant", "onClick"], [3, "icon", "height", "width", "ariaHidden"], ["width", "12", "height", "14", "viewBox", "0 0 12 14", "fill", "none", "xmlns", "http://www.w3.org/2000/svg"], ["d", "M6.14097 3.28571H2.92669L5.56955 1.28571C5.85526 1 5.85526 0.5 5.56955 0.214286C5.28383 -0.0714286 4.78383 -0.0714286 4.49812 0.214286L0.640974 3.28571C0.426688 3.5 0.355259 3.71429 0.426688 4C0.355259 4.21429 0.426688 4.5 0.640974 4.64286L4.56955 8.07143C4.85526 8.35714 5.35526 8.35714 5.64097 8.07143C5.92669 7.78571 5.92669 7.28571 5.64097 7L2.85526 4.71429H6.14097C8.28383 4.71429 10.0695 6.5 10.0695 8.64286C10.0695 10.7857 8.28383 12.5714 6.14097 12.5714H3.64097C3.2124 12.5714 2.92669 12.8571 2.92669 13.2857C2.92669 13.7143 3.2124 14 3.64097 14H6.14097C9.06955 14 11.4981 11.5714 11.4981 8.64286C11.4981 5.71429 9.06955 3.28571 6.14097 3.28571Z", "fill", "#003D7A"]],
      template: function SelectedTagsComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0)(1, "div", 1, 2);
          i0.ɵɵtemplate(3, SelectedTagsComponent_div_3_Template, 2, 5, "div", 3)(4, SelectedTagsComponent_ng_container_4_Template, 2, 1, "ng-container", 4);
          i0.ɵɵelementContainer(5, 5);
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(6, SelectedTagsComponent_div_6_Template, 4, 6, "div", 6);
          i0.ɵɵelementStart(7, "div", 7, 8);
          i0.ɵɵelementContainer(9, 5);
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(10, SelectedTagsComponent_ng_template_10_Template, 1, 7, "ng-template", null, 9, i0.ɵɵtemplateRefExtractor)(12, SelectedTagsComponent_ng_template_12_Template, 2, 0, "ng-template", null, 10, i0.ɵɵtemplateRefExtractor)(14, SelectedTagsComponent_ng_template_14_Template, 4, 3, "ng-template", null, 11, i0.ɵɵtemplateRefExtractor)(16, SelectedTagsComponent_ng_template_16_Template, 4, 5, "ng-template", null, 12, i0.ɵɵtemplateRefExtractor)(18, SelectedTagsComponent_ng_template_18_Template, 2, 0, "ng-template", null, 13, i0.ɵɵtemplateRefExtractor);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          const _r10 = i0.ɵɵreference(15);
          i0.ɵɵproperty("id", ctx.id);
          i0.ɵɵadvance(3);
          i0.ɵɵproperty("ngForOf", ctx.visibleItems);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.showAll);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngTemplateOutlet", _r10);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngForOf", ctx.tagsSource);
          i0.ɵɵadvance(3);
          i0.ɵɵproperty("ngTemplateOutlet", _r10);
        }
      },
      dependencies: [i2.ChipComponent, i3.NgForOf, i3.NgIf, i3.NgTemplateOutlet, i4.ButtonComponent, i5.IconComponent],
      styles: [".sol-selected-tags .sol-tags-wrapper{display:flex;flex-wrap:wrap}.sol-selected-tags .sol-tags-wrapper>.sol-tag-horizontal{margin-right:.25rem;margin-bottom:.5rem}.sol-selected-tags .sol-tags-wrapper>.sol-tag-horizontal:last-child{margin-right:0}.sol-selected-tags .sol-selected-tags-buttons-container{display:inline-flex;gap:.25rem;align-items:flex-start}.sol-selected-tags .sol-selected-tags-buttons-container .show-more .sol-button{padding:0 .3rem;min-width:unset}.sol-selected-tags .focusable-chip{cursor:pointer;appearance:none;border:none;background:none;padding:0}.sol-selected-tags .focusable-chip:focus-visible{outline:solid var(--color-globalstate-focus) var(--outline-width)}.sol-selected-tags .focusable-chip.large{height:2.25rem;border-radius:.25rem}.sol-selected-tags .focusable-chip.large:focus-visible{outline-offset:.187rem}.sol-selected-tags .focusable-chip.medium{height:1.75rem;border-radius:.25rem}.sol-selected-tags .focusable-chip.medium:focus-visible{outline-offset:.187rem}.sol-selected-tags .focusable-chip.small{height:1.25rem;border-radius:.25rem}.sol-selected-tags .focusable-chip.small:focus-visible{outline-offset:.125rem}.sol-selected-tags .show-less{display:inline-block}.sol-selected-tags .invisible{visibility:hidden;position:absolute}\n"],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SelectedTagsComponent, [{
    type: Component,
    args: [{
      selector: 'sol-selected-tags',
      changeDetection: ChangeDetectionStrategy.OnPush,
      encapsulation: ViewEncapsulation.None,
      template: "<div class=\"sol-selected-tags\" [id]=\"id\">\n  <div class=\"sol-tags-wrapper\" #tagWrapperEleRef>\n    <div class=\"sol-tag-horizontal visible-items chip-item\" *ngFor=\"let item of visibleItems; let i = index\">\n      <ng-container [ngTemplateOutlet]=\"tagTemplate\" [ngTemplateOutletContext]=\"{ tag: item, chipIndex: i }\"></ng-container>\n    </div>\n    <ng-container *ngIf=\"showAll\">\n      <div class=\"sol-tag-horizontal hidden-items chip-item\" *ngFor=\"let item of hiddenItems; let j = index\">\n        <ng-container [ngTemplateOutlet]=\"tagTemplate\" [ngTemplateOutletContext]=\"{ tag: item, chipIndex: visibleItems.length + j }\"></ng-container>\n      </div>\n    </ng-container>\n    <ng-container [ngTemplateOutlet]=\"actionButtons\"></ng-container>\n  </div>\n\n  <div class=\"sol-tag-container invisible\" *ngFor=\"let item of tagsSource\" #invisibleItemEleRef>\n    <sol-chip\n      chipTabIndex=\"-1\"\n      #invisibleChips\n      [allowClose]=\"removable\"\n      [label]=\"item[label]\"\n      [subLabel]=\"item[subLabel]\"\n      [size]=\"tagSize\"\n      [id]=\"'sol-invisible-chip-' + item[primaryKey]\"\n      [attr.data-primary-value]=\"item[primaryKey]\"\n    ></sol-chip>\n  </div>\n\n  <div class=\"invisible\" #invisibleMoreEleRef>\n    <ng-container [ngTemplateOutlet]=\"actionButtons\"></ng-container>\n  </div>\n\n  <ng-template #tagTemplate let-tag=\"tag\" let-chipIndex=\"chipIndex\">\n    <sol-chip\n      [chipTabIndex]=\"chipIndex === 0 ? '0' : '-1'\"\n      [allowClose]=\"removable\"\n      [label]=\"tag.labelText\"\n      [subLabel]=\"tag.subLabelText\"\n      [size]=\"tagSize\"\n      [id]=\"'sol-visible-chip-' + tag.primaryValue\"\n      (closed)=\"removeItem(tag)\"\n      [variant]=\"variant\"\n      (chipKeydown)=\"onChipKeydown($event, chipIndex)\"\n      (closeButtonKeydown)=\"onCloseButtonKeydown($event, chipIndex)\"\n    ></sol-chip>\n  </ng-template>\n\n  <ng-template #ShowLessIcon>\n    <svg width=\"10\" height=\"12\" viewBox=\"0 0 10 12\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path\n        d=\"M5.12087 2.81633H2.36577L4.63107 1.10204C4.87597 0.857143 4.87597 0.428571 4.63107 0.183673C4.38618 -0.0612245 3.9576 -0.0612245 3.71271 0.183673L0.406584 2.81633C0.22291 3 0.161686 3.18367 0.22291 3.42857C0.161686 3.61224 0.22291 3.85714 0.406584 3.97959L3.77393 6.91837C4.01883 7.16327 4.4474 7.16327 4.6923 6.91837C4.9372 6.67347 4.9372 6.2449 4.6923 6L2.30454 4.04082H5.12087C6.9576 4.04082 8.48822 5.57143 8.48822 7.40816C8.48822 9.2449 6.9576 10.7755 5.12087 10.7755H2.97801C2.61067 10.7755 2.36577 11.0204 2.36577 11.3878C2.36577 11.7551 2.61067 12 2.97801 12H5.12087C7.63107 12 9.71271 9.91837 9.71271 7.40816C9.71271 4.89796 7.63107 2.81633 5.12087 2.81633Z\"\n        fill=\"#767676\"\n      />\n    </svg>\n  </ng-template>\n\n  <ng-template #actionButtons>\n    <div class=\"sol-selected-tags-buttons-container\">\n      <sol-button\n        #showMoreEleRef\n        class=\"show-more\"\n        *ngIf=\"hiddenItems.length > 0 && !showAll\"\n        [id]=\"'show-more-container-' + id\"\n        [variant]=\"'basic'\"\n        [size]=\"tagSize\"\n        [iconPositionedFront]=\"plusCount\"\n        [ariaLabel]=\"showMoreAriaLabel\"\n        (onClick)=\"showMore()\"\n      ></sol-button>\n      <sol-button\n        #showLessEleRef\n        class=\"show-less\"\n        *ngIf=\"hiddenItems.length > 0 && showAll\"\n        (onClick)=\"showLess()\"\n        [id]=\"'show-less-container-' + id\"\n        [variant]=\"'basic'\"\n        [size]=\"tagSize\"\n        [iconPositionedFront]=\"backArrow\"\n        >{{ showLessLabel }}</sol-button\n      >\n      <sol-button\n        *ngIf=\"visibleItems.length + hiddenItems.length > 0 && allowClearAll\"\n        [size]=\"tagSize\"\n        [variant]=\"'text'\"\n        class=\"clear-all\"\n        (onClick)=\"clearAllTags()\"\n        >{{ clearAllLabel }}\n      </sol-button>\n    </div>\n  </ng-template>\n\n  <ng-template #plusCount>\n    <span>\n      <sol-icon [icon]=\"'sol-plus'\" [height]=\"'0.65rem'\" [width]=\"'0.65rem'\" [ariaHidden]=\"true\"></sol-icon>\n      <span>{{ hiddenItems.length }}</span>\n    </span>\n  </ng-template>\n\n  <ng-template #backArrow>\n    <svg width=\"12\" height=\"14\" viewBox=\"0 0 12 14\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path\n        d=\"M6.14097 3.28571H2.92669L5.56955 1.28571C5.85526 1 5.85526 0.5 5.56955 0.214286C5.28383 -0.0714286 4.78383 -0.0714286 4.49812 0.214286L0.640974 3.28571C0.426688 3.5 0.355259 3.71429 0.426688 4C0.355259 4.21429 0.426688 4.5 0.640974 4.64286L4.56955 8.07143C4.85526 8.35714 5.35526 8.35714 5.64097 8.07143C5.92669 7.78571 5.92669 7.28571 5.64097 7L2.85526 4.71429H6.14097C8.28383 4.71429 10.0695 6.5 10.0695 8.64286C10.0695 10.7857 8.28383 12.5714 6.14097 12.5714H3.64097C3.2124 12.5714 2.92669 12.8571 2.92669 13.2857C2.92669 13.7143 3.2124 14 3.64097 14H6.14097C9.06955 14 11.4981 11.5714 11.4981 8.64286C11.4981 5.71429 9.06955 3.28571 6.14097 3.28571Z\"\n        fill=\"#003D7A\"\n      />\n    </svg>\n  </ng-template>\n</div>\n",
      styles: [".sol-selected-tags .sol-tags-wrapper{display:flex;flex-wrap:wrap}.sol-selected-tags .sol-tags-wrapper>.sol-tag-horizontal{margin-right:.25rem;margin-bottom:.5rem}.sol-selected-tags .sol-tags-wrapper>.sol-tag-horizontal:last-child{margin-right:0}.sol-selected-tags .sol-selected-tags-buttons-container{display:inline-flex;gap:.25rem;align-items:flex-start}.sol-selected-tags .sol-selected-tags-buttons-container .show-more .sol-button{padding:0 .3rem;min-width:unset}.sol-selected-tags .focusable-chip{cursor:pointer;appearance:none;border:none;background:none;padding:0}.sol-selected-tags .focusable-chip:focus-visible{outline:solid var(--color-globalstate-focus) var(--outline-width)}.sol-selected-tags .focusable-chip.large{height:2.25rem;border-radius:.25rem}.sol-selected-tags .focusable-chip.large:focus-visible{outline-offset:.187rem}.sol-selected-tags .focusable-chip.medium{height:1.75rem;border-radius:.25rem}.sol-selected-tags .focusable-chip.medium:focus-visible{outline-offset:.187rem}.sol-selected-tags .focusable-chip.small{height:1.25rem;border-radius:.25rem}.sol-selected-tags .focusable-chip.small:focus-visible{outline-offset:.125rem}.sol-selected-tags .show-less{display:inline-block}.sol-selected-tags .invisible{visibility:hidden;position:absolute}\n"]
    }]
  }], () => [{
    type: i0.ChangeDetectorRef
  }, {
    type: i1.TranslationService
  }], {
    id: [{
      type: Input
    }],
    tagsSource: [{
      type: Input
    }],
    removable: [{
      type: Input
    }],
    tagSize: [{
      type: Input
    }],
    variant: [{
      type: Input
    }],
    allowClearAll: [{
      type: Input
    }],
    primaryKey: [{
      type: Input
    }],
    label: [{
      type: Input
    }],
    subLabel: [{
      type: Input
    }],
    maxTagsToDisplay: [{
      type: Input
    }],
    tagsChanged: [{
      type: Output
    }],
    viewMoreClicked: [{
      type: Output
    }],
    viewLessClicked: [{
      type: Output
    }],
    tagDeleted: [{
      type: Output
    }],
    deleteAllClicked: [{
      type: Output
    }],
    showMoreEleRef: [{
      type: ViewChild,
      args: ['showMoreEleRef', {
        static: false,
        read: ElementRef
      }]
    }],
    showLessEleRef: [{
      type: ViewChild,
      args: ['showLessEleRef', {
        static: false,
        read: ElementRef
      }]
    }],
    invisibleMoreEleRef: [{
      type: ViewChild,
      args: ['invisibleMoreEleRef', {
        static: false
      }]
    }],
    tagWrapperEleRef: [{
      type: ViewChild,
      args: ['tagWrapperEleRef', {
        static: false
      }]
    }],
    invisibleItemsRef: [{
      type: ViewChildren,
      args: ['invisibleItemEleRef']
    }],
    invisibleChips: [{
      type: ViewChildren,
      args: ['invisibleChips']
    }]
  });
})();
class SelectedTagsModule {
  static {
    this.ɵfac = function SelectedTagsModule_Factory(t) {
      return new (t || SelectedTagsModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: SelectedTagsModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [ChipModule, CommonModule, ButtonModule, IconModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SelectedTagsModule, [{
    type: NgModule,
    args: [{
      declarations: [SelectedTagsComponent],
      imports: [ChipModule, CommonModule, ButtonModule, IconModule],
      exports: [SelectedTagsComponent]
    }]
  }], null, null);
})();

/*
 * Public API Surface of selected-tags
 */

/**
 * Generated bundle index. Do not edit.
 */

export { SelectedTagsComponent, SelectedTagsModule };
